import { Id } from '@nextforce/api'

const keys = {
  all: ['crew_list'],
  list: (storeId: Id) => [...keys.all, storeId],
}

export default keys
